"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrokerageOptionList = exports.UnderlyingTermDeprecatedList = exports.UnderlyingTermList = exports.PaymentTimeUnitList = exports.DocumentIssuerDeprecatedList = exports.DocumentIssuerList = exports.DocumentTypeDeprecatedList = exports.DocumentTypeList = exports.PackingOptionList = exports.PackingTypeList = exports.ShippingClassificationList = exports.ShippingOptionList = exports.DeliveryOptionList = exports.DeliveryTermList = exports.FumigationTypeDeprecatedList = exports.FumigationTypeList = exports.QualityWeightTermList = exports.QualityCategoryList = exports.QualityTypeList = exports.QualityAllowanceList = exports.ToleranceUnitList = exports.ToleranceOptionList = exports.CropYearList = exports.GoodsOptionList = exports.ContractStatusList = exports.WeightUnitsListWithoutPounds = void 0;
const weight_units_types_1 = require("@myfrey/weight-units-types");
exports.WeightUnitsListWithoutPounds = weight_units_types_1.WeightUnitsList.filter((value) => value != "Pound");
exports.ContractStatusList = [
    "Draft",
    "Approved",
    "Washed out",
    "Being executed",
    "Completed",
    "Cancelled",
];
exports.GoodsOptionList = ["Buyer's", "Liner's", "Seller's"];
exports.CropYearList = ["2021/2022", "2022/2023", "2023/2024", "2024/2025"];
exports.ToleranceOptionList = [`Buyer's`, `Seller's`];
exports.ToleranceUnitList = [...exports.WeightUnitsListWithoutPounds, "%"];
exports.QualityAllowanceList = [
    "1:1 allowance in proportional fraction",
    "2:1 allowance in proportional fraction",
    "3:1 allowance in proportional fraction",
];
exports.QualityTypeList = ["%", "g", "kg/hl", "lbs/bu", "ppb", "ppm", "sec"];
exports.QualityCategoryList = [
    "Foreign grain",
    "Plump kernels",
    "Oil content ",
    "Color",
    "Varietal purity",
    "Protein",
    "Carbon grains",
    "Dark hard vitreous (DHV)",
    "Thin kernels",
    "Falling number",
    "Tannin",
    "Other colors",
    "Bug damage",
    "Scab damage",
    "Aflatoxin",
    "Total damaged kernels",
    "Screenings",
    "Mould",
    "Ergot",
    "Broken corn",
    "Crude fiber",
    "W value",
    "Phorate",
    "Dry matter",
    "Other beans and purple beans",
    "Damaged kernels",
    "Soybean of other colors",
    "Dockage",
    "Shrunk and broken kernels",
    "Total defects",
    "Test weight",
    "Splits",
    "Sprout damage",
    "Non-GMO purity",
    "Hard vitreous kernels",
    "Contrasting classes",
    "Fiber",
    "Barley retained over 2.5mm long holed sieve",
    "Deoxynivalenol",
    "Unmillable material",
    "Heat damaged kernels",
    "Purity",
    "Blight or scab damage",
    "Retention",
    "Mycotoxins don",
    "Broken corn and foreign material",
    "Vomitoxin",
    "Ash",
    "Moisture",
    "Variety",
    "Barley passing through 2.2mm long holed sieve",
    "Crude fat",
    "Damaged kernel (black tip)",
    "Fat",
    "Foreign material",
    "Germination",
    "Cadmium",
    "Sand/Silica",
    "Tilletia controversa huhn or TCK",
    "Peeled and broken",
    "Lead",
    "Wheat of other classes",
    "Dehulled",
    "Broken kernels and foreign material",
    "Wet gluten",
    "Defective",
    "Grasshopper and locusts",
    "Zearalenone",
    "Stones",
    "% Bleached",
    "Hunter L score",
    "Thousand kernel weight",
    "Profat",
    "Ochrotoxin A",
    "Total other classes",
    "Aflatoxin B1",
];
exports.QualityWeightTermList = [
    "Quality and weight final at point of stuffing the container as per certificate by government official or independent surveyor",
    "Quality and weight final at point of unloading as per certificate by government official or independent surveyor",
    "Quality and weight final at point of loading of railcars as per certificate by government official or independent surveyor",
    "Quality and weight final at point of loading of trucks as per certificate by government official or independent surveyor",
    "Quality and weight final at point of stuffing the container as per certificate by FGIS, government official at the stuffing location or independent surveyor",
    "Quality and weight final at point of unloading as per certificate by FGIS, government official at the stuffing location or independent surveyor",
    "Quality and weight final at point of loading of railcars as per certificate by FGIS, government official at the stuffing location or independent surveyor",
    "Quality and weight final at point of loading of trucks as per certificate by FGIS, government official at the stuffing location or independent surveyor",
    "Quality and weight final as per destination weights and quality at registered weighbridge",
    "Quality and weight final as per origin weights and quality at registered weighbridge",
    "Quality and weight final at point of loading the trucks as per the certified weight ticket by the independent surveyor subject to discount or rejection at destination",
    "Quality and weight final at point of unloading the trucks as per the certified weight ticket by the independent surveyor subject to discount or rejection at destination",
    "Quality and weight final as per relevant Bulk Handling Company's warehouse receipt(s), warehouse warrant(s), or title transfer(s)",
];
exports.FumigationTypeList = [
    "Phosphine standard - fumigated in storage bin",
    "Phosphine - fumigated in container",
    "Phosphine Vietnam -  to be fumigated in container",
    "Phosphine Thailand - to be fumigated in container",
    "Methyl Bromide",
    "As per GAFTA Fumigation Rules No. 132",
    "Fumigated as per DCT contract #4",
    "Aluminum Phosphide",
];
/**
 * Deprecated
 * @deprecated
 */
exports.FumigationTypeDeprecatedList = [];
exports.DeliveryTermList = [
    "FREE ON TRUCK",
    "FREE IN STORE",
    "CIP",
    "EXW",
    "DAP TRUCK",
    "CFR",
    "DELIVERED SITE",
    "FREE IN STORE (WA)",
    "CPT",
    "DPU",
    "CIF",
    "FOB",
    "DDP",
    "DCT",
    "EX-FARM",
    "FOB TRUCK",
    "FCA",
    "DELIVERED",
    "FAS",
    "TRACK",
    "DAP",
];
exports.DeliveryOptionList = [`Buyer's`, `Seller's`];
exports.ShippingOptionList = [`Buyer's option`, `Seller's option`, `Buyer's call`, "Prompt", "Immediate"];
exports.ShippingClassificationList = ["US East Coast", "US West Coast"];
exports.PackingTypeList = [
    "20-ft standard",
    "40-ft high cube",
    "40-ft standard",
    "Bulk",
    "Rail cars",
    "Trucks",
];
exports.PackingOptionList = [`Buyer's`, `Liner's`, `Seller's`];
/**
 * Deprecated documents types:
 * ISCC Certification
 * Courier Receipt
 * Booking Confirmation
 */
exports.DocumentTypeList = [
    "Grain Commodity Vendor Declaration",
    "Document instructions",
    "Loading instructions",
    "Cover letter from Bank - CAD bank",
    "Independent Certificate",
    "Beneficiary Certificate",
    "Statement of Assurance: Heavy Metals",
    "Non-GMO Certificate",
    "Import Permit",
    "Bill of Lading - Sea Waybill",
    "Container Cleanliness Certificate",
    "Statement of Assurance: Canadian Origin",
    "Radiation Certificate",
    "Bill of Lading - Rail cars",
    "Grade Certificate",
    "Non-Transgenic Certificate",
    "Prior Notice",
    "Statement of Assurance: Aflatoxin and Ochratoxin A",
    "Recipient Created Tax Invoice (RCTI)",
    "Verified Gross Mass (VGM)",
    "Soybean Export Sustainability Certificate",
    "Cover letter from Bank - LC",
    "Certificate of Weight",
    "Statement of Assurance: Microbiology",
    "Fumigation in bins",
    "Stuffing instructions",
    "Statement of Assurance: Radionuclides",
    "Shipping instructions",
    "Cover letter Frey - LC",
    "Railway Bill",
    "AQIS/DAFF Inspection Certificate",
    "Destination Scale Tickets",
    "Destination scale tickets certificates",
    "Pesticide Certificate",
    "GMP + B3 Certificate",
    "Statement of Assurance: Zearalenone",
    "Chemical Residues Certificate",
    "Heavy Metals Certificate",
    "Halal Certificate",
    "Human Consumption Certificate",
    "Scab certificate",
    "Labelling Statement",
    "Delivery Report",
    "Fumigation Certificate",
    "Certificate stating 3 previous cargoes shipped by the container",
    "Stowage Certificate",
    "Act of Acceptance and Transfer",
    "Crop Year Certificate",
    "Proforma invoice",
    "Commercial Invoice",
    "Mycotoxin Certificate",
    "Certificate of Analysis",
    "Non-Radioactivity Certificate",
    "Non-Irradiation Certificate",
    "Official Export Grain Inspection",
    "Cover letter Frey - CAD bank",
    "Export Certificate for Animal Products",
    "ISCC Certification",
    "Non-GMO Strip Test",
    "Phytosanitary Certificate",
    "I-106 Form",
    "Statement of Assurance: Pesticides Residue",
    "Statement of Assurance Request",
    "Statement of Assurance for Radioactivity",
    "Certificate of Quality",
    "Shipping Certificate",
    "Custom Declaration",
    "Draft Drawn",
    "Mycotoxin and Aflatoxin Certificate",
    "Report of Certification Research",
    "Certificate of Origin",
    "Letter of Analysis: No live insects, no fumigation",
    "Non-Wood Packing Certificate",
    "Freight Certificate",
    "Sample Submission Form",
    "Relationship Statement Letter",
    "Statement Letter",
    "Certificate of Laboratory",
    "White Certificate",
    "Statement of Assurance: Mycotoxins",
    "Korea-US Free Trade Agreement Certificate of Origin",
    "Ethylene Oxide Free Beneficiary Certificate",
    "Statement of Assurance: Non-GMO",
    "Statement of Assurance: Karnal Bunt",
    "Radioactivity Certificate",
    "Statement of Assurance: Human Consumption",
    "Wood Packing Certificate",
    "Sustainability Certificate",
    "Truck Bill of Lading",
    "Title transfer",
    "Railcar Order",
    "Statement of Assurance for Glyphosate",
    "Insurance Certificate",
    "Titanium Dioxide Free Beneficiary Certificate",
    "Railcar Variance",
    "Declaration Statement",
    "Bill of Lading - Original",
    "Packing List",
    "SGS Form",
    "GMO Certificate with events",
    "Melamine-free Declaration Certificate",
    "GMO Certificate without events",
    "Microbiology Certificate",
    "Rail car list",
    "Vomitoxin Certificate",
    "Certificate of Aflatoxin",
    "FGIS-921-2",
    "Packing Instructions",
    "Health Certificate",
    "Origin scale tickets certificates",
    "Letter of Analysis: Vomitoxin",
    "Intertek Analysis Request",
    "Commoditiy Inspection Certificate",
    "Courier Waybill",
    "Export Inspection Certificate",
];
/**
 * @deprecated
 */
exports.DocumentTypeDeprecatedList = ["Test document type", "Courier Receipt", "Booking Confirmation"];
exports.DocumentIssuerList = [
    "FGIS or USDA",
    "Government Authority",
    "Intertek",
    "FGIS or USDA or Independent Surveyor",
    "U.S. Soy Sustainability Assurance Protocol",
    "FGIS",
    "Independent Surveyor",
    "3rd party surveyor",
    "Beneficiary",
    "USDA",
    "USDA or Independent Surveyor",
    "Independent Laboratory",
    "CPTPP",
    "Seller",
    "CGC",
    "Carrier",
    "Frey",
    "Chamber of Commerce",
    "Logistics Service Provider",
    "Buyer",
    "CFIA",
    "Transloader",
    "Seller via bulk handler",
    "Haulier",
    "FGIS or Independent Surveyor",
    "SGS",
    "FGIS or FGIS approved entity",
    "Bank",
    "USDA/FGIS",
    "USDA/FGIS or Independent Surveyor",
    "USDA/FGIS or Transloader or Shipper",
    "CGC or Independent Surveyor",
    "CGC or Transloader or Shipper",
];
/**
 * @deprecated
 */
exports.DocumentIssuerDeprecatedList = [];
exports.PaymentTimeUnitList = ["Calendar days", "Hours", "Working days"];
exports.UnderlyingTermList = [
    "NGFA Trade Rules and Arbitration Rules",
    "GAFTA 88 with GAFTA 125",
    "GTA No 4 DCT",
    "COPA Trade Rules",
    "CSCA",
    "GAFTA 89",
    "GTA No. 3",
];
/**
 * @deprecated
 */
exports.UnderlyingTermDeprecatedList = ["GTA No. 2", "GTA No. 6"];
exports.BrokerageOptionList = ["Buyer", "Seller"];
